import { observer } from 'mobx-react-lite';
import AdvancedSearch from './AdvancedSearch';
import SearchRefinersCallout from './SearchRefinersCallout';
import { setRefinersVisibility } from '../actions/internalActions';
import getSearchRefinersButtonStrings from '../selectors/getSearchRefinersButtonStrings';
import { getStore } from '../store/store';
import isSharedFolderSearch from '../utils/isSharedFolderSearch';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { AriaProperties, AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
import { logUsage } from 'owa-analytics';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import * as React from 'react';
import { FILTERS_BUTTON_ID } from '../searchConstants';
import { SearchScenarioId } from 'owa-search';

const styles = require('./SearchRefiners.scss');

export default observer(function SearchRefiners(props: {}) {
    const refinersButton = React.useRef<HTMLElement>();
    const onClick = (evt: React.MouseEvent<unknown>) => {
        evt.stopPropagation();
        // Determine search refiners visiblity.
        const refinersVisible = getStore().refinersVisible;
        const newRefinersVisibility = !refinersVisible;
        // Log click on filters button, and if the click is to show or hide UI.
        logUsage('Search_AdvancedSearchButtonClicked', [
            newRefinersVisibility,
            SearchScenarioId.Mail,
        ]);
        // Set visiblity of advanced search UI.
        setRefinersVisibility(newRefinersVisibility);
    };
    const searchRefinersButtonStrings = getSearchRefinersButtonStrings();
    const refinersVisible = getStore().refinersVisible;
    const ariaProperties: AriaProperties = {
        role: AriaRoles.button,
        hasPopup: true,
        label: searchRefinersButtonStrings.ariaLabel,
        expanded: refinersVisible,
    };
    // In case of shared folders, attachment refiner is not supported.
    const showAttachmentRefiner = !isSharedFolderSearch();
    const advancedSearchComponent = isFeatureEnabled('sea-advanced-search') ? (
        <AdvancedSearch showAttachmentRefiner={showAttachmentRefiner} />
    ) : (
        <SearchRefinersCallout
            target={refinersButton.current}
            showAttachmentRefiner={showAttachmentRefiner}
        />
    );
    return (
        <>
            <button
                id={FILTERS_BUTTON_ID}
                title={searchRefinersButtonStrings.buttonTitle}
                className={
                    isFeatureEnabled('sea-colors')
                        ? styles.refinersButtonNeutral
                        : styles.refinersButton
                }
                onClick={onClick}
                ref={ref => (refinersButton.current = ref)}
                {...generateDomPropertiesForAria(ariaProperties)}>
                {!isFeatureEnabled('sea-folderScope') && (
                    <span className={styles.refinersButtonText}>
                        {searchRefinersButtonStrings.buttonText}
                    </span>
                )}
                <Icon iconName={ControlIcons.ChevronDown} className={styles.refinersButtonIcon} />
            </button>

            {refinersVisible && advancedSearchComponent}
        </>
    );
});
